import AdminReducer from './AdminReducer'
import CampaignEmployeeReducer from './CampaignEmployeeReducer'
import CampaignReducer from './CampaignReducer'
import CompanyReducer from './CompanyReducer'
import EmployeeReducer from './EmployeeReducer'
import FormReducer from './FormReducer'
import JobReducer from './JobReducer'
import UserReducer from './UserReducer'

import { configureStore } from '@reduxjs/toolkit'

export const store = configureStore({
  reducer: {
    admin: AdminReducer,
    campaign: CampaignReducer,
    campaignEmployee: CampaignEmployeeReducer,
    company: CompanyReducer,
    employee: EmployeeReducer,
    form: FormReducer,
    job: JobReducer,
    user: UserReducer,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
